import { render, staticRenderFns } from "./LoanView.vue?vue&type=template&id=313548d1&"
import script from "./LoanView.vue?vue&type=script&lang=js&"
export * from "./LoanView.vue?vue&type=script&lang=js&"
import style0 from "./LoanView.vue?vue&type=style&index=0&id=313548d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports